import React from 'react';
import { motion } from 'framer-motion';
import { reveal } from './Showcase';
import { StoreButtons } from './StoreButtons';

export const DownloadBand = () => (
  <section id="download" className="lp-section lp-section--paper" data-testid="download-section">
    <motion.div {...reveal()} className="lp-wrap lp-band">
      <div>
        <span className="lp-eyebrow">Ready for your next shift?</span>
        <h2 className="lp-h2">Try every tool free for 7 days.</h2>
        <p className="lp-muted" data-testid="download-pricing">Then $7.99/month. Cancel anytime in the App Store or Google Play. No ShiftReady account, no IT ticket.</p>
      </div>
      <StoreButtons prefix="download" showWebButton={false} />
    </motion.div>
  </section>
);
